import { ArrowLeftOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Space, Form, Input, notification } from "antd";
import { store } from "../../store/index.store";
import "./UserProfile.scss";
import { useNavigate } from "react-router-dom";
//import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import editButton from "../../assets/images/editButton.png";
import Modal from "antd/lib/modal/Modal";
import { useState } from "react";
import { ProfileImage } from "../UploadableProfileImage/ProfileImage";
import { dateDeltaTextGen } from "../../common/utils/dateDeltaTextGen";
import { changePassword, sendOtp } from "../../api/authorisation";

export const UserProfile = observer(() => {
  const { authStore } = store;
  const navigate = useNavigate();
  // const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();

  const [submitedOtp, setSubmitedOtp] = useState(false);

  const saveChanges = async () => {
    if (!submitedOtp) {
      if (form.getFieldValue("email") !== authStore.userProfile.email) {
        console.log(authStore.userProfile.email, form.getFieldValue("email"));
        notification.error({
          message: "Error",
          description: "Email doesnt match",
        });

        return;
      }

      await sendOtp({ email: form.getFieldValue("email") });

      setSubmitedOtp(true);
    } else {
      if (form.getFieldValue("email") !== authStore.userProfile.email) {
        console.log(authStore.userProfile.email, form.getFieldValue("email"));
        notification.error({
          message: "Error",
          description: "Email doesnt match",
        });

        return;
      }

      if (
        form.getFieldValue("password") !==
        form.getFieldValue("password-confirm")
      ) {
        notification.error({
          message: "Error",
          description: "Passwords do not match",
        });

        return;
      }

      if (!form.getFieldValue("otp")) {
        notification.error({
          message: "Error",
          description: "Please enter the OTP",
        });

        return;
      }

      await changePassword({
        email: form.getFieldValue("email"),
        otp: form.getFieldValue("otp"),
        password: form.getFieldValue("password"),
      });
      setOpen(true);
    }
  };

  return (
    <div
      className="c-profile-setting"
      style={{
        display: "contents",

        padding: "10px",
        width: "50%",
        margin: 10,
      }}
    >
      <Breadcrumb style={{ padding: "20px", justifyContent: "center" }}>
        <Breadcrumb.Item onClick={() => navigate(-1)}>
          <ArrowLeftOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Profile</Breadcrumb.Item>
        <Breadcrumb.Item>Profile settings</Breadcrumb.Item>
      </Breadcrumb>

      <ProfileImage />

      <div className="c-profile-setting__username">
        {authStore.userProfile.fullName || "Loading..."}
      </div>
      <div className="c-profile-setting__userjointime">
        {dateDeltaTextGen(
          new Date().getTime(),
          authStore.userProfile.createdAt
        )}
      </div>
      <div className="c-profile-setting__form-holder">
        <Form
          form={form}
          name="dynamic_form_nest_item"
          autoComplete="off"
          layout="vertical"
          className="c-profile-setting__form"
        >
          <label className="c-profile-setting__profile_label">
            Edit profile
          </label>
          <Form.Item style={{ width: "350px" }} name="email">
            <Input
              height={50}
              className="c-profile-setting__input"
              placeholder="email@provider.com"
              suffix={
                <img
                  src={editButton}
                  alt="edit button"
                  width={"30px"}
                  height={"30px"}
                  className="c-profile-setting__editButton"
                />
              }
            />
          </Form.Item>
          <label className="c-profile-setting__email-label" htmlFor="email">
            Confirm Current E-Mail address
          </label>
          <label className="c-profile-setting__security">Security</label>
          <label className="c-profile-setting__profile_label">
            New Password
          </label>
          <Form.Item style={{ width: "350px" }} name="password">
            <Input
              height={50}
              type="password"
              className="c-profile-setting__input"
              placeholder="****************"
              suffix={
                <img
                  src={editButton}
                  alt="edit button"
                  width={"30px"}
                  height={"30px"}
                  className="c-profile-setting__editButton"
                />
              }
            />
          </Form.Item>
          <label className="c-profile-setting__email-label" htmlFor="password">
            New password
          </label>
          <label className="c-profile-setting__profile_label">
            Confirm New Password
          </label>
          <Form.Item style={{ width: "350px" }} name="password-confirm">
            <Input
              height={50}
              type="password"
              className="c-profile-setting__input"
              placeholder="****************"
              suffix={
                <img
                  src={editButton}
                  alt="edit button"
                  width={"30px"}
                  height={"30px"}
                  className="c-profile-setting__editButton"
                />
              }
            />
          </Form.Item>
          <label
            className="c-profile-setting__email-label"
            htmlFor="password-confirm"
          >
            New password again
          </label>

          {submitedOtp && (
            <>
              <label className="c-profile-setting__profile_label">
                Enter the OTP you got on the mail
              </label>
              <Form.Item style={{ width: "350px" }} name="otp">
                <Input
                  height={50}
                  className="c-profile-setting__input"
                  placeholder="Enter OTP code"
                  inputMode="numeric"
                />
              </Form.Item>
              <p>
                Reminder: Also check your spam folder for the OTP email. <br />
                If you still can't find it, please request a new OTP.
              </p>
              <label className="c-profile-setting__email-label" htmlFor="otp">
                Enter OTP code
              </label>
            </>
          )}
          {
            <div style={{ display: "flex" }}>
              <Button
                className="c-profile-setting__success-modal-button"
                type="primary"
                shape="round"
                onClick={saveChanges}
              >
                Submit changes
              </Button>
            </div>
          }

          <Form.Item>
            {
              <>
                <Modal
                  open={open}
                  onCancel={() => setOpen(false)}
                  footer={[
                    <Button
                      className="c-profile-setting__success-modal-button-footer"
                      key="okay"
                      onClick={() => setOpen(false)}
                    >
                      Okay
                    </Button>,
                  ]}
                  className="c-profile-setting__success-modal"
                  centered={true}
                >
                  <Space direction="vertical">
                    <label className="c-profile-setting__success-modal-header">
                      Congratulations!
                    </label>
                    <label className="c-profile-setting__success-modal-message">
                      Your new email and password have been updated.
                    </label>
                  </Space>
                </Modal>
              </>
            }
          </Form.Item>
        </Form>
      </div>
    </div>
  );
});
